import algorithms_dcm from "./dcm/prediction";
import algorithms_crt from "./crt/prediction";
import algorithms_ef from "./ef/prediction";

export default [...algorithms_ef, ...algorithms_dcm, ...algorithms_crt];
